import { FC, ReactNode } from 'react';

import { StyledCell } from '../Grid';
import type { RecommendedResearchItem } from '../model';
import { ResearchItem } from './ResearchItem';

interface RecommendedResearchProps {
  data: ReadonlyArray<RecommendedResearchItem>;
  className?: string;
}

type GridProps = RecommendedResearchProps &
  Readonly<{
    render: (item: RecommendedResearchItem) => ReactNode;
  }>;
export const RecommendedResearchGrid: FC<GridProps> = ({ data, className, render }) => (
  <>
    {data.map((item, idx) => (
      <StyledCell key={item.sourceId} $rowIndex={idx} className={className}>
        {render(item)}
      </StyledCell>
    ))}
  </>
);
RecommendedResearchGrid.displayName = 'RecommendedResearchGrid';

export const RecommendedResearch: FC<RecommendedResearchProps> = ({ data, className }) => (
  <RecommendedResearchGrid
    data={data}
    className={className}
    render={({ title, date, link, author, sourceId, countOfReading }) => (
      <ResearchItem
        title={title}
        date={date}
        link={link}
        author={author}
        key={sourceId}
        countOfReading={countOfReading}
      />
    )}
  />
);

RecommendedResearch.displayName = 'RecommendedResearch';
